/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

/**
 * Flex Row styling
 */
export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin: 0;
  }

  p {
    margin: 0;
    margin-right: 20px;
  }
`;

/**
 * Error styling
 */
export const ErrorWrapper = styled.span`
  margin-left: 20px;
  color: red;
  font-size: 14px;
`;
